import { render, staticRenderFns } from "./happy51.vue?vue&type=template&id=136da4d0&scoped=true&"
import script from "./happy51.vue?vue&type=script&lang=js&"
export * from "./happy51.vue?vue&type=script&lang=js&"
import style0 from "./happy51.vue?vue&type=style&index=0&id=136da4d0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136da4d0",
  null
  
)

export default component.exports